module.exports = __webpack_public_path__ + "static/media/future_3.660f0dc9.jpg";